import ProductVariantSimpleStore from './ProductVariantSimpleStore'

export default ProductVariantSimpleStore
